import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';


@Component({
    selector: 'app-reloj',
    standalone: true,
    templateUrl: './app-reloj.component.html',
    styleUrls: ['./app-reloj.component.css']
})
export class AppRelojComponent implements OnInit, OnDestroy {
  hora = "00";
  minutos = "00";
  fecha = "";
  segundos = "00";
  private subscription?: Subscription;

  constructor() { }

  ngOnInit() {
      this.actualizarReloj();
      this.subscription = timer(0, 1000).subscribe(() => this.actualizarReloj());
  }

  ngOnDestroy() {
      this.subscription?.unsubscribe();
  }

  private actualizarReloj() {
      const ahora = new Date();
      this.hora = String(ahora.getHours()).padStart(2, '0');
      this.minutos = String(ahora.getMinutes()).padStart(2, '0');
      this.segundos = String(ahora.getSeconds()).padStart(2, '0');
      this.fecha = ahora.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
      });
  }
}
